import { render, staticRenderFns } from "./BaseTrend.vue?vue&type=template&id=042136a8"
import script from "./BaseTrend.vue?vue&type=script&lang=js"
export * from "./BaseTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports